import { useCallback, useEffect, useMemo, useState } from 'react';
import cities from '../data/cities';

// Persisted home timezone, kept in sync with localStorage so / and /v2
// agree on which city is "home". Falls back to the first selected city
// when the saved name is no longer in the user's list (e.g. after delete).
export function useHomeTimezone(selectedTimezones) {
  const [homeTimezoneName, setHomeTimezoneName] = useState(
    () => localStorage.getItem('homeTimezone') || (selectedTimezones?.[0]?.name) || null
  );

  useEffect(() => {
    if (homeTimezoneName && !selectedTimezones.some(tz => tz.name === homeTimezoneName)) {
      const fallback = selectedTimezones?.[0]?.name || null;
      setHomeTimezoneName(fallback);
      if (fallback) localStorage.setItem('homeTimezone', fallback);
      else localStorage.removeItem('homeTimezone');
    }
  }, [selectedTimezones, homeTimezoneName]);

  const setHomeCity = useCallback((cityName) => {
    setHomeTimezoneName(cityName);
    if (cityName) localStorage.setItem('homeTimezone', cityName);
    else localStorage.removeItem('homeTimezone');
  }, []);

  const homeCity = useMemo(() => {
    if (homeTimezoneName) {
      const c = cities.find(c => c.name === homeTimezoneName);
      if (c) return c;
    }
    return selectedTimezones?.[0] || null;
  }, [homeTimezoneName, selectedTimezones]);

  return { homeCity, setHomeCity };
}
